export default "__VITE_PUBLIC_ASSET__e827ea23__"